import LegalLayout, { COMPANY } from "./LegalLayout";

export default function IptalIade() {
  return (
    <LegalLayout eyebrow="Yasal Belge" title="İptal ve İade Koşulları" updated="8 Şubat 2026">
      {/* Prominent legal callout box */}
      <div className="not-prose border-2 p-5 sm:p-6 mb-8" style={{ borderColor: "var(--gold)", background: "linear-gradient(135deg, rgba(212,175,55,0.10), rgba(212,175,55,0.02))" }}>
        <div className="label-caps mb-2" style={{ color: "var(--gold)" }}>YASAL BİLGİLENDİRME · CAYMA HAKKI</div>
        <p className="text-white text-base leading-relaxed m-0">
          <strong>Dijital içerik ve yazılım hizmetleri, anlık ifa edilen hizmetler kapsamında olduğundan cayma hakkı kapsamı dışındadır</strong> (6502 sayılı Tüketicinin Korunması Hakkında Kanun md. 15 ve Mesafeli Sözleşmeler Yönetmeliği md. 15/ğ). Buna rağmen {COMPANY.brand}, iyi niyet göstergesi olarak aşağıdaki gönüllü iade politikasını uygular.
        </p>
      </div>

      <p>{COMPANY.brand}, dijital bir yazılım hizmetidir (SaaS). 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği'nde belirtilen istisnalar saklı kalmak kaydıyla aşağıdaki iptal ve iade politikası uygulanır.</p>

      <h2>1. Cayma Hakkı ve İstisnası</h2>
      <p>Elektronik ortamda anında ifa edilen ve tüketiciye anında teslim edilen dijital yazılım hizmetlerinde kural olarak <strong>cayma hakkı bulunmamaktadır</strong> (Mesafeli Sözleşmeler Yönetmeliği md. 15/ğ). Bu istisnaya rağmen {COMPANY.brand} müşterilerine ek koruma olarak aşağıdaki iade koşullarını sunar.</p>

      <h2>2. 3 Günlük Koşulsuz İade</h2>
      <p>İlk kez abone olan kullanıcılar için, hizmetin ilk aktivasyonundan itibaren <strong>3 (üç) takvim günü içinde</strong> herhangi bir gerekçe göstermeksizin abonelik iptal edilebilir ve ödenen ücretin tamamı iade edilir.</p>
      <ul>
        <li>Talep <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> adresine e-posta ile ya da {COMPANY.phone} numarasına telefon ile iletilmelidir.</li>
        <li>İade, aynı ödeme yöntemine (kart hesabına) 7-14 iş günü içinde yapılır.</li>
        <li>Hizmet iptali anında devreye girer; sonraki dönem otomatik yenileme kapatılır.</li>
      </ul>

      <h2>3. 3 Gün Sonrası İptal</h2>
      <p>3 günlük iade süresinin sonrasında, kullanıcı istediği zaman aboneliğini iptal edebilir. Ancak <strong>başlamış olan aylık dönemin ücreti iade edilmez</strong>; hizmet, ilgili ayın sonuna kadar aktif kalır ve devamında otomatik yenileme yapılmaz.</p>

      <h2>4. Teknik Kaynaklı İadeler</h2>
      <p>Sistemden kaynaklanan ve {COMPANY.brand} teknik ekibinin makul süre içinde çözemediği <strong>kritik bir arıza</strong> nedeniyle hizmet kullanılamaz hale gelirse, arıza süresine denk gelen orantılı bir ücret iadesi yapılır. Bu talep e-posta ile başvurulur ve olay kayıtları (log) üzerinden değerlendirilir.</p>

      <h2>5. İade Kapsamı Dışındaki Durumlar</h2>
      <ul>
        <li>Kullanıcının hesabını kendi ihmali sonucu (şifre kaybı, yetkisiz erişim vs.) kaybetmesinden doğan taleplerde iade yapılmaz.</li>
        <li>Kullanım Koşulları'na aykırı davranış nedeniyle askıya alınan hesaplar iade kapsamı dışındadır.</li>
        <li>Üçüncü taraf entegrasyonlarının (WhatsApp, e-posta sağlayıcı, banka POS vs.) kesintileri {COMPANY.brand}'in sorumluluğu dışında olduğundan iade konusu edilmez.</li>
      </ul>

      <h2>6. İade Başvurusu</h2>
      <p>Tüm iade talepleri için:</p>
      <ul>
        <li><strong>E-posta:</strong> <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
        <li><strong>Telefon:</strong> {COMPANY.phone}</li>
        <li><strong>Adres:</strong> {COMPANY.address}</li>
      </ul>
      <p>Talep, kayıt altına alınır ve en geç 3 iş günü içinde yanıtlanır.</p>
    </LegalLayout>
  );
}
